<template>
    <v-app dark>
        <a id="hubble-logo" href="https://hubble.fi" :class="{loading: loading}">
            <template v-if="svgSupport">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 153 68" style="enable-background:new 0 0 153 68;" xml:space="preserve">
                    <g class="st0">
                        <defs>
                            <rect id="SVGID_3_" x="0" y="0" width="153.13" height="68"/>
                        </defs>
                        <clipPath id="SVGID_4_">
                            <use xlink:href="#SVGID_3_" style="overflow:visible;"/>
                        </clipPath>
                        <path class="st1" d="M31.07,33.77v-1.13c0-0.74,0.35-1.13,1.2-1.13h6.09c-0.04,1.52-0.07,2.87-0.07,4.43     c0,3.97,2.55,6.55,6.41,6.55c2.28,0,4.14-1,5.56-2.34c0.91,1.15,2.28,1.8,4.07,1.8c3.01,0,4.92-1.59,5.91-3.47l0.14,0.04v0.11     c0,1.88,1.88,3.33,4.78,3.33c2.98,0,5.22-1.61,6.67-3.67c1.36,2.21,3.63,3.67,6.77,3.67c5.28,0,8.64-3.51,8.64-8.22     c0-0.5-0.11-0.96-0.28-1.45c0.32,0.04,0.64,0.04,0.99,0.04c0.36,0,0.73-0.01,1.09-0.04v0.15c0,5.13,2.83,9.53,8.29,9.53     c5.28,0,8.64-3.51,8.64-8.22c0-1.8-0.49-3.29-1.26-4.31c-1.17-1.54-3.2-1.9-3.82-1.1c-0.72,0.92-1.55,2.28-1.55,2.76     c0,0.21,0.11,0.32,0.25,0.43c0.89,0.64,1.31,1.42,1.31,2.51c0,1.98-1.45,3.47-3.29,3.47c-2.73,0-3.65-2.94-3.65-5.31v-0.82     c4.29-1.38,9.17-4.92,9.17-9.49c0-3.36-2.59-5.53-5.77-5.53c-5.95,0-8.32,5.67-8.32,11.76v0.34c-0.15,0.01-0.29,0.01-0.41,0.01     c-3.19,0-4.64-1.03-5.53-1.03c-0.57,0-2.48,3.01-2.48,3.65c0,0.21,0.11,0.32,0.25,0.43c0.89,0.64,1.31,1.42,1.31,2.51     c0,1.98-1.45,3.47-3.29,3.47c-2.73,0-3.65-2.94-3.65-5.31v-0.82c4.29-1.38,9.18-4.96,9.18-9.53c0-3.36-2.59-5.49-5.77-5.49     c-5.95,0-8.32,5.67-8.32,11.76v4.32c0,0.35,0.01,0.7,0.04,1.05c-0.63,1.6-2.12,4.02-3.77,4.02c-1.1,0-1.74-1.13-1.74-2.51     c0-2.55,0.43-7.76,0.43-8.43c0-0.67-0.35-1.03-1.03-1.03h-3.3c-0.67,0-0.96,0.39-0.96,0.99v1.17c0,5.28-1.95,9.81-4.07,9.81     c-1.49,0-1.95-1.06-1.95-3.15c0-2.37,0.25-5.63,0.25-7.86c0-0.57-0.36-0.96-0.99-0.96h-3.29c-0.64,0-0.99,0.32-0.99,0.99v9.24     c0,0.13,0,0.25,0.01,0.37c-0.87,1.1-1.96,1.9-3.19,1.9c-1.74,0-2.23-1.24-2.23-3.29c0-6.09,0.35-13.53,0.35-16.61     c0-0.57-0.32-0.99-0.92-0.99h-3.22c-0.64,0-0.96,0.35-0.96,0.99c0,1.81-0.18,6.62-0.25,8.5h-5.07c-1.59,0-2.01,0.76-2.37,1.29     v-6.75v-3.05c0-0.67-0.39-0.99-1.03-0.99h-6.11c-4.15,0-7.65,2.52-7.65,6.98c0,3.79,3.12,6.27,4.6,6.27     c0.18,0,0.28-0.14,0.46-0.39c0.53-0.71,1.66-2.83,1.66-3.33c0-0.14-0.03-0.21-0.25-0.32c-0.78-0.39-1.74-1.21-1.74-2.27     c0-1.74,1.59-2.48,3.47-2.48h2.18c-0.35,0.53-0.6,1.81-0.6,3.12v8.39c0,2.83-0.75,4.92-2.76,4.92c-0.81,0-1.45-0.5-1.95-0.92     c-0.25-0.21-0.39-0.32-0.57-0.32c-0.43,0-2.44,2.69-2.44,3.22c0,0.46,1.66,2.48,4.89,2.48C28.7,42.48,31.07,37.91,31.07,33.77      M97.34,20.45c0.81,0,1.31,0.5,1.31,1.35c0,2.02-2.23,4.18-4.64,5.31C94.23,23.42,95.25,20.45,97.34,20.45 M78.62,20.45     c0.81,0,1.31,0.5,1.31,1.35c0,2.02-2.23,4.18-4.64,5.31C75.5,23.42,76.53,20.45,78.62,20.45"/>
                        <path class="st1" d="M134.26,35.2c-2.42,4.45-7.57,3.7-8.33,2.42c3.33-0.97,6.51-4.68,5.13-8.4c-1.04-2.83-4.06-4.38-7.16-3.24     c-3.18,1.17-4.71,3.95-4.73,7.01c-0.01,1.82,0.35,3.25,0.79,4.25c0,0-0.85,0.85-3.26,0.92c-3.55-0.11-4.71-2.31-4.71-5.52v-0.96     c4.82-1.59,9.21-4.99,9.21-9.53c0-3.3-2.44-5.49-5.88-5.49c-5.42,0-8.22,5.1-8.22,11.76v4.36c0,5.38,2.5,9.14,8.2,9.47     l-0.01,0.03c0.2,0,0.4,0,0.58,0c0.09,0,0.17,0,0.26,0l0-0.01c2.47-0.07,3.88-0.47,6.28-1.91c1.14,0.75,2.87,1.75,5.05,1.94     c4.73,0.42,7.86-1.43,8.99-3.88C137.1,37.04,134.7,34.39,134.26,35.2 M115.32,20.77c0.89,0,1.38,0.64,1.38,1.52     c0,2.34-2.73,4.14-4.68,5.14C112.16,24.35,113.15,20.77,115.32,20.77 M124.03,30.53c0.68-1.48,2.6-1.48,3.13-0.64     c0.6,0.96,0.41,2.22-0.33,3.07c-1.22,1.38-3.07,2.19-3.07,2.19S122.92,32.94,124.03,30.53"/>
                        <path class="st1" d="M128.58,50.31c-0.64-0.21-1.3-0.37-1.96-0.46c-9.06-1.29-17.25-2.12-25.27-2.67     c-2.12-0.15-4.19-0.26-6.27-0.36c-2.08-0.1-4.15-0.18-6.21-0.25c-4.11-0.1-8.23-0.17-12.34-0.12     c-8.24,0.08-16.51,0.44-25.13,1.16c-8.51,0.71-17.26,1.72-26.97,3.24c-0.32,0.06-0.59,0.13-0.83,0.19     c-0.26,0.07-0.19,0.46,0.08,0.44c4.18-0.37,16.86-1.46,24.38-1.86c9.23-0.49,18.84-0.77,28.48-0.78c4.83,0,9.66,0.04,14.48,0.17     c2.4,0.05,4.8,0.12,7.19,0.21c2.39,0.09,4.78,0.2,7.13,0.31c8.13,0.4,16.11,0.98,23.4,1.62c0.42,0.04,0.57-0.54,0.18-0.71     C128.8,50.39,128.68,50.34,128.58,50.31"/>
                    </g>
                </svg>
            </template>
            <template v-else>
                <img src="/images/hubble-logo.png" alt="Hubble Oy" />
            </template>
        </a>
        <Tutorial v-if="$vuetify.breakpoint.lgAndUp"></Tutorial>
        <v-content>
            <Teachable @updateLoadingStatus="onUpdateLoadingStatus"/>
        </v-content>
    </v-app>
</template>

<script>
import Teachable from './components/Teachable.vue'
import Tutorial from './components/Tutorial.vue'

export default {
  name: 'app',
  components: {
    Teachable,
    Tutorial
  },
  data() {
    return {
      loading: true,
      svgSupport: true,
    }
  },
  methods: {
    onUpdateLoadingStatus(value) {
      this.loading = value;
    },
  },
  mounted() {
    this.svgSupport = document.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#BasicStructure", "1.1");
    /* eslint-disable no-console */
    console.log("*****************************************************\n" +
      " _    _           _       _       _\n" +
      "| |  | |         | |     | |     | |\n" +
      "| |__| |  _   _  | |__   | |__   | |   ___\n" +
      "|  __  | | | | | | '_ \\  | '_ \\  | |  / _ \\\n" +
      "| |  | | | |_| | | |_) | | |_) | | | |  __/\n" +
      "|_|  |_|  \\__,_| |_.__/  |_.__/  |_|  \\___| - LABS\n" +
      "\n" +
      "Hubble Teachable Machine experiment is based on Google Teachable Machine Boilerplate project (https://github.com/googlecreativelab/teachable-machine-boilerplate).\n" +
      "\n" +
      "*****************************************************");
    /* eslint-enable no-console */
  }
}
</script>

<style lang="scss" scoped>
    #hubble-logo {
        height: 68px;
        width: 153px;
        position: absolute;
        top: 0;
        left: 0;
        display: inline-block;
        z-index: 9999;

        object, img {
            max-width: 100%;
            height: auto;
        }

        &:after {
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            content: "";
        }
    }
</style>

<style lang="scss">
    .theme--dark.application {
        background: #06323d !important;
    }

    .st1{
        clip-path:url(#SVGID_4_);
        fill:#DCFFFF;
        transition: fill 0.4s ease-in-out;
    }

    .loading {
        .st1{
            clip-path:url(#SVGID_4_);
            fill:#006a64;
        }
    }

    .hb-heading {
        font-family: 'Belgrano', serif !important;
        color: #dcffff;
        font-size: 18px;
        margin-bottom: 10px;
    }

</style>